import styled from "styled-components";
import { Device } from "../../../../styles/screenSizes";

export const StyledUserWrapper = styled.div`
  @media ${Device.laptop} {
    display: none;
  }

  height: 60px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.header?.shop?.backgroundColor || "#fff"};
  border-bottom: 1px solid #ebebeb;
`;

export const StyledLink = styled.a<{ full?: boolean }>`
  text-decoration: none;
  color: ${({ theme }) =>
    theme.header?.shop?.mobileLinkColor || theme.color.primary};
  width: 50%;
  text-align: center;
  cursor: pointer;

  ${({ full }) => full && ` width: 100%`};
`;

export const StyledDivider = styled.div`
  height: 60px;
  border-right: 1px solid #ebebeb;
`;
